import React, { useState, useEffect, useRef } from 'react'
import { firestore } from '../Firebase/utils'
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { Grid, TextField, Typography } from '@mui/material'
import ChatMessage from '../Components/ChatMessage';
import { useSelector } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import SendIcon from '@mui/icons-material/Send';

const mapUserState = ({ user }) => ({
    currentUser: user.currentUser
})

const mapUserDataState = ({user}) => ({
    userProfileData: user.userProfileData
})


const mapStudentDataState = ({user}) => ({
  studentData: user.studentData
})

export const AdminChat = () => {

    const [message, setMessage] = useState()
    const messagesEndRef = useRef(null)
    const { currentUser } = useSelector(mapUserState)
    const { userProfileData } = useSelector(mapUserDataState)
    const { studentData } = useSelector(mapStudentDataState)
    
    const messagesRef = firestore.collection(`private-messages/${studentData.id}/chat`)
    const studentQuery = messagesRef.orderBy('createdAt').limit(25)
    

    const [studentMessages] = useCollectionData(studentQuery, {idField: 'id'})

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
      }

    useEffect(() => {
        scrollToBottom()
      }, [studentMessages]);

    const textFieldStyle = {'& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: '#262A34',
          color:'#FFF'
        },
        '&:hover fieldset': {
          color:'#FFF'
        },
        '&.Mui-focused fieldset': {borderColor: '#262A34',
          color:'#FFF'
        },
        color:'#FFF',
      }, label:{color:'#FFF'}}
      
    const sendMessage = async() => {
        const uid = currentUser.uid
        const studentUid = studentData.id
        const userName = userProfileData.firstName + ' ' + userProfileData.lastName
        await messagesRef.add({
            text: message,
            createdAt: new Date(),
            uid,
            studentUid,
            userName 
        })
        setMessage('')
    }

  return (<>
    <Grid container display='flex' direction='row' justifyContent='center' position='relative' sx={{backgroundColor:'#181824', pt:1, maxHeight:'100vh'}}>
         <Grid item container justifyContent='center'>
             <Typography variant='h5' color='#FFF' fontSize={25} fontWeight='bold'>{studentData ? `${studentData.data().firstName}'s Private Chat` : 'Private Chat'}</Typography>
         </Grid>
         <Grid container direction='row' sx={{width: '100%', height: '80vh', overflowY:'auto'}}>
             <Grid item spacing={{xs:4}} alignItems='center' xs={12} sx={{backgroundColor:'transparent', pb:9, px:1 }}>
                 <Grid item elevation={10} direction='column' spacing={{xs:2}} sx={{ backgroundColor: 'inherit'}}>
                     {studentMessages && studentMessages.map(msg => <ChatMessage key={msg.id} message={msg} myMessage={msg.uid === currentUser.uid}/>)}
                 </Grid>
                 <div ref={messagesEndRef} />      
             </Grid>
             <Grid item container position='absolute' bottom={0} xs={12} sx={{width:'100%', backgroundColor:'#262A34'}}>
                 <Grid item xs={10}><TextField fullWidth label='Enter Message...' value={message} onChange={(e) => { setMessage(e.target.value) }} sx={textFieldStyle}/></Grid>
                     <IconButton color="primary" aria-label="add" size='large' onClick={() => {sendMessage()}}><SendIcon /></IconButton>
             </Grid>
         </Grid> 
     </Grid>
  </>)

}


